const animation = require("./Dave Speech Bubble.json");

module.exports = {
    loop: false,
    autoplay: true,
    prerender: true,
    renderer: "svg",
    animationData: animation,
    rendererSettings: {
        preserveAspectRatio: 'xMidyMid'
    },
}